export * from './crm/classification';
export * from './crm/company';
export * from './crm/contact';
export * from './crm/delivery_method';
export * from './crm/offer';
export * from './crm/offer_package';
export * from './crm/offer_product';
export * from './crm/payment_condition';
export * from './crm/pricelist';
export * from './crm/representative';

export * from './shop/country';
export * from './shop/region';
export * from './shop/winery';
export * from './shop/color';
export * from './shop/favorite';
export * from './shop/grape';
export * from './shop/tastetype';
export * from './shop/appellation';
export * from './shop/volume';
export * from './shop/image';
export * from './shop/product';
export * from './shop/product_image';
export * from './shop/product_stock';
export * from './shop/shop_user';
export * from './shop/shop_order';
export * from './shop/order';
export * from './shop/order_item';
export * from './shop/order_document';
export * from './shop/order_log';
export * from './shop/shippingcost';
export * from './shop/shippingcost_price';
export * from './shop/voucher';

export * from './selectItem';
export * from './user';
export * from './system-country';
export * from './province';

export * from './profile';
export * from './subscription';
export * from './settings';
export * from './dashboard_data';



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/models/index.ts